import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { requestPasswordReset, resetPassword } from '../services/authApi';
import './Pages.css';

export const PasswordRecovery: React.FC = () => {
  const location = useLocation();
  const resetting = location.pathname === '/reset-password';
  const token = new URLSearchParams(location.search).get('token') || '';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError('');
    if (resetting && (!token || !/^[a-f0-9]{64}$/.test(token))) { setError('Link inválido. Solicite um novo link de recuperação.'); return; }
    if (resetting && password !== confirmation) { setError('As senhas não coincidem.'); return; }
    setBusy(true);
    try {
      if (resetting) await resetPassword(token, password);
      else await requestPasswordReset(email.trim());
      setPassword(''); setConfirmation(''); setDone(true);
    } catch (failure) {
      setError(failure instanceof Error ? failure.message : 'Não foi possível concluir a solicitação.');
    } finally { setBusy(false); }
  };

  return <div className="ns-login"><div className="ns-login-panel">
    <div className="ns-login-header"><div className="ns-login-logo"><span className="mark">NS</span><span className="text">NutriSync</span></div>
      <h1 style={{ fontSize: '1.35rem' }}>{resetting ? 'Definir nova senha' : 'Recuperar acesso'}</h1>
    </div>
    {done ? <p role="status">{resetting ? 'Senha atualizada. Entre novamente com sua nova senha.' : 'Se o e-mail estiver cadastrado, enviaremos um link de recuperação. Confira também a pasta de spam.'}</p> :
      <form className="ns-login-form" onSubmit={submit}>
        {resetting ? <>
          <label className="ns-field"><span>Nova senha</span><input className="ns-input" type="password" autoComplete="new-password" minLength={10} required value={password} onChange={e => setPassword(e.target.value)} /></label>
          <label className="ns-field"><span>Confirme a nova senha</span><input className="ns-input" type="password" autoComplete="new-password" minLength={10} required value={confirmation} onChange={e => setConfirmation(e.target.value)} /></label>
          <p>Use pelo menos 10 caracteres.</p>
        </> : <label className="ns-field"><span>E-mail cadastrado</span><input className="ns-input" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} /></label>}
        {error && <p className="ns-login-error" role="alert">{error}</p>}
        <div className="ns-form-actions"><Button type="submit" disabled={busy}>{busy ? 'Enviando...' : resetting ? 'Salvar nova senha' : 'Enviar link de recuperação'}</Button></div>
      </form>}
    <p className="ns-login-footer"><Link to="/login">Voltar para entrar</Link></p>
  </div></div>;
};
